exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wspo-main-title-accent{background-color:var(--color-bg-dark);color:var(--color-alt);padding:0 4px}.wspo-theme-pm .wspo-main-title-accent{color:var(--color-text)}", ""]);
